import { Redirect } from "expo-router";

export default function AuthCallback() {
  return <Redirect href="/" />;
}
